import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import Toggle from "react-toggle";
import { Tooltip } from "react-tippy";
import { arrayMoveImmutable as arrayMove } from "array-move";
import { fabric } from "fabric";
import AfterpayBreakdown from "components/afterpay/AfterpayBreakdown";
import ShippingEstimate from "components/cart/ShippingEstimate";
import CurrencyDisplay from "components/helpers/CurrencyDisplay";
import MultiPhotoCanvas from "components/multi-photo/MultiPhotoCanvas";
import FrameStyleSelector from "components/frame-designer/designers/FrameStyleSelector";
import AddToCartButton from "components/frame-designer/designers/AddToCartButton";

class MultiPhotoDesigner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image_windows: props.image_windows,
      images: props.images || new Array(props.image_windows.length),
      frame_style: props.frame_style,
      viesus_correct: true,
      addingToCart: false,
      frame_style: props.frame_styles.find(
        (obj) => obj.id === props.frame_style_id
      ),
    };
    this.onSortEnd = this.onSortEnd.bind(this);
    this.newPhoto = this.newPhoto.bind(this);
    this.onClear = this.onClear.bind(this);
    this.getCartCookie = this.getCartCookie.bind(this);
    this.saveToShopify = this.saveToShopify.bind(this);
    this.saveOrderItem = this.saveOrderItem.bind(this);
    this.saveItem = this.saveItem.bind(this);
    this.saveImageToDatabase = this.saveImageToDatabase.bind(this);
    this.imageLoaded = this.imageLoaded.bind(this);
    this.updateFrameStyle = this.updateFrameStyle.bind(this);
    this.toggleViesus = this.toggleViesus.bind(this);
    this.newEffects = this.newEffects.bind(this);
  }

  componentDidMount() {
    this.setState({ maxWidth: this.refs.container.offsetWidth });
  }

  toggleViesus() {
    this.setState({ viesus_correct: !this.state.viesus_correct }, () =>
      this.newEffects()
    );
  }

  newEffects() {
    const { images, viesus_correct } = this.state;

    if (images.filter((x) => x).length > 0) {
      this.setState({ imageLoading: true });

      $.ajax({
        method: "PUT",
        url: this.props.toggle_viesus_url,
        data: {
          image_ids: images.filter((x) => x).map((x) => x.id),
          viesus_correct: viesus_correct,
        },
      }).done(
        function (data, textStatus, jqXHR) {
          data.images.map((image, index) =>
            this.imageSaveSuccess(image, index)
          );
        }.bind(this)
      );
    }
  }

  newPhoto(index) {
    return (info) => this.saveImageToDatabase(info, index);
  }

  onClear(index) {
    return () => {
      const { images } = this.state;
      let newImages = [...images];

      newImages[index] = null;
      this.setState({ images: newImages });
    };
  }

  saveImageToDatabase(fileInfo, index) {
    console.log(fileInfo);

    const newImage = {
      width: fileInfo.width,
      height: fileInfo.height,
      filename: fileInfo.original_filename,
      external_id: fileInfo.public_id,
      host: "cloudinary",
      path: "path",
      source: "direct",
      url: fileInfo.secure_url,
      filesize: fileInfo.bytes,
      format: fileInfo.format,
      viesus_correct: this.state.viesus_correct,
    };

    if (fileInfo.coordinates != null) {
      newImage.cx = fileInfo.coordinates.custom[0][0];
      newImage.cy = fileInfo.coordinates.custom[0][1];
      newImage.cw = fileInfo.coordinates.custom[0][2];
      newImage.ch = fileInfo.coordinates.custom[0][3];
    }

    $.ajax({
      method: "PUT",
      url: this.props.post_image_url,
      data: {
        image: newImage,
      },
    }).done(
      function (data, textStatus, jqXHR) {
        this.imageSaveSuccess(data, index);
      }.bind(this)
    );
  }

  imageSaveSuccess({ image }, index) {
    const { images, image_windows } = this.state;
    let newImages = [...images];

    newImages[image_windows[index].position - 1] = image;
    this.setState({ images: newImages, imageLoading: image.id });
  }

  onSortEnd({ oldIndex, newIndex }) {
    const { image_windows, images } = this.state;

    const newWins = arrayMove(image_windows, oldIndex, newIndex);
    const newImages = arrayMove(images, oldIndex, newIndex);

    this.setState({ image_windows: newWins, images: newImages });
  }

  getCartCookie() {
    let a = `; ${document.cookie}`.match(`;\\s*cart=([^;]+)`);
    if (a) {
      console.log("Cart Cookie Found :)");
      return a[1].slice(-10);
    } else {
      console.log("Getting Cookie via cart.json");
      $.ajax({
        method: "GET",
        url: window.Shopify.routes.root + "cart.json",
      }).done(function (data) {
        return data.token.slice(-10);
      });
    }
  }

  saveItem() {
    const { image_windows, images } = this.state;
    const {
      post_to_cart_url,
      prices,
      is_edit_mode,
      template_variants,
      template_purchase_id,
    } = this.props;

    this.setState({ addingToCart: true });

    let image_window_purchases_attributes = images.map((item, index) => {
      return {
        image_id: item.id,
        image_window_id: image_windows.find(
          (item) => item.position - 1 == index
        ).id,
      };
    });

    $.ajax({
      method: is_edit_mode ? "PUT" : "POST",
      url: post_to_cart_url,
      data: {
        template_purchase_id: template_purchase_id,
        template_purchase: {
          template_variant_id: template_variants.find(
            (item) => item.frame_style_colour_id == this.state.frame_style.id
          ).id,
          glass_type_id: this.props.glass_type.id,
          template_id: this.props.id,
          image_window_purchases_attributes: image_window_purchases_attributes,
        },
      },
    }).done(this.saveToShopify);
  }

  saveToShopify(productableData) {
    console.log(productableData);

    if (productableData.save_to_shopify == false) {
      this.saveOrderItem(productableData);
    } else {
      if (this.props.shopify_line_id) {
        this.deleteShopifyLineItem(productableData);
      } else {
        this.saveShopifyLineItem(productableData);
      }
    }
  }

  saveShopifyLineItem(productableData) {
    let shopify_variant_id = this.props.prices.find(
      (item) => item.id == this.state.frame_style.id
    ).shopify_variant_id;

    console.log("Saving Variant to Shopify: " + shopify_variant_id);

    let shopifyData = {
      items: [
        {
          id: shopify_variant_id,
          quantity: 1,
          properties: productableData.shopify_properties,
        },
      ],
    };

    console.log(shopifyData);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(shopifyData),
    })
      .then((response) => {
        if (response.ok) {
          console.log("SAVED TO SHOPIFY");
          if (this.props.shopify_line_id) {
            window.location.href = "/cart";
          } else {
            this.saveOrderItem(productableData);
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  deleteShopifyLineItem(productableData) {
    console.log("DELETING SHOPIFY LINE ITEM");

    let data = {
      id: this.props.shopify_line_id,
      quantity: 0,
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        this.saveShopifyLineItem(productableData);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  saveOrderItem(productableData) {
    let cart_id;
    if (productableData.save_to_shopify == true) {
      cart_id = this.getCartCookie();
      productableData.cart_id = cart_id;

      console.log(cart_id);
    }

    let draftOrderItem = {
      shopify_cart_id: cart_id,
      draft_order_item: {
        productable_id: productableData.productable_id,
        productable_type: productableData.productable_type,
      },
    };

    $.ajax({
      method: "POST",
      url: this.props.draft_order_items_path,
      data: draftOrderItem,
    })
      .done(this.saveSuccess)
      .fail(this.saveFail);
  }

  saveSuccess(data) {
    console.log(data);
    window.location.href = data.redirect_to;
  }

  imageLoaded(id) {
    if (this.state.imageLoading == id) {
      console.log("finished loading: " + id);
      this.setState({ imageLoading: null });
    }
  }

  updateFrameStyle(style) {
    this.setState({ frame_style: style.frame_style });
  }

  render() {
    const {
      image_windows,
      images,
      imageLoading,
      frame_style,
      maxWidth,
      viesus_correct,
    } = this.state;
    const { prices } = this.props;

    let actualImages = images.filter((item) => item);
    let remaining = image_windows.length - actualImages.length;
    let disabled = remaining > 0 ? "disabled" : null;
    let buttonClasses = classNames(
      "btn",
      "btn-primary",
      "btn-lg",
      "btn-block",
      disabled
    );
    let numberWords = ["Two", "Three", "Four"];
    let the_price = prices.find((item) => item.id == frame_style.id).price;

    return (
      <div>
        <div>
          <div className="md:grid md:grid-cols-12 md:gap-x-8 ">
            <div className="md:order-2 md:col-span-7 ">
              <div className="relative aspect-1 bg-pale" ref="container">
                <div className="absolute w-full h-full flex justify-center items-center">
                  <div
                    className={classNames(
                      "absolute flex justify-center items-center",
                      this.props.width_mm > this.props.height_mm
                        ? "!w-[85%]"
                        : "!h-[85%] w-full",
                      imageLoading && "blur-sm"
                    )}
                  >
                    <MultiPhotoCanvas
                      {...this.props}
                      maxWidth={maxWidth}
                      windows={image_windows}
                      images={images}
                      viesus={viesus_correct}
                      imageLoading={this.imageLoading}
                      imageLoaded={this.imageLoaded}
                      frame_style={frame_style}
                    />
                  </div>
                  {imageLoading && (
                    <div className="absolute left-1/2 top-1/2 -ml-[25px] -mt-[25px] w-12 bg-white rounded-lg p-2">
                      <img src={this.props.preloader} />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="md:order-3 md:col-span-5 max-w-md">
              <div className="mx-3 lg:mt-16">
                <h1 className="mt-4 tracking-tighter md:mt-0 mb-2">
                  Add your photos
                </h1>
                <p className="text-muted">
                  {numberWords[image_windows.length - 2]}{" "}
                  {image_windows[0].size_desc} photos in a{" "}
                  {this.props.frame_size} frame.
                </p>

                <div className="mini-heading mb-3 mt-7">
                  Frame style:{" "}
                  <span className="text-muted">
                    {this.state.frame_style.title}
                  </span>
                </div>
                <FrameStyleSelector
                  saveValues={this.updateFrameStyle}
                  options={this.props.frame_styles}
                  defaultChecked={this.state.frame_style}
                  name="Frame style"
                  groupName="frame_style"
                />
                <div className="mini-heading mb-2 mt-7">
                  Your photos
                  {remaining == 0 ? (
                    <span className="text-success float-right">
                      👍 All photos uploaded. Nice work!
                    </span>
                  ) : (
                    <span className="text-muted float-right mr-3">
                      <i className="fa-solid fa-circle-exclamation"></i>{" "}
                      {remaining} {remaining == 1 ? "photo" : "photos"}{" "}
                      remaining to upload
                    </span>
                  )}
                </div>
                <SortableContainer
                  lockAxis="y"
                  onSortEnd={this.onSortEnd}
                  useDragHandle
                >
                  {image_windows.map((value, index) => (
                    <SortableItem
                      public_key={this.props.public_key}
                      key={`item-${value.id}`}
                      index={index}
                      value={value}
                      onChange={this.newPhoto(index)}
                      onClear={this.onClear(index)}
                      minPixelsW={this.props.min_pixels_width}
                      minPixelsH={this.props.min_pixels_height}
                      image={images[index]}
                    />
                  ))}
                </SortableContainer>
                <div className="mini-heading mt-2 ml-2 text-xxs text-stone-400">
                  <i className="fa-solid fa-bars mr-2"></i> Drag to adjust the
                  order
                </div>
                <div className="my-3"></div>

                <div className="effects mt-4">
                  <div className="my-3">
                    <Toggle
                      id="orientation"
                      icons={false}
                      defaultChecked={viesus_correct}
                      onChange={this.toggleViesus}
                    />
                    <label
                      style={{ top: "-8px", position: "relative" }}
                      className="ml-2 mini-heading"
                      htmlFor="orientation"
                    >
                      <span className="text-dark">
                        <i className="fa-solid fa-glasses-round mr-1"></i>{" "}
                        {viesus_correct ? "Smart Enhance On" : "Enhance Off"}
                        <Tooltip
                          title="Automatically adjusts brightness & color, restores sharpness, removes noise and corrects for overexposure or underexposure"
                          distance={10}
                          position="top"
                          arrow={true}
                        >
                          <i className="fa-solid fa-circle-question"></i>
                        </Tooltip>
                      </span>
                    </label>
                  </div>
                </div>

                <React.Fragment>
                  <div className="pb-3 mt-6">
                    <div className="my-3">
                      <AddToCartButton
                        price={the_price}
                        tax_rate={this.props.tax_rate}
                        onClickEvent={this.saveItem}
                        buttonText="Add to cart"
                        disabled={disabled || this.state.addingToCart}
                        afterpayLogo={this.props.afterpayUI.logo_white}
                        isLoading={this.state.addingToCart}
                      />
                    </div>
                    <ShippingEstimate
                      shipping_icon={this.props.shipping_icon}
                      shipping_estimates={this.props.shipping_estimates}
                      print_and_frame={true}
                      country={this.props.country_name}
                      location="multi-photo"
                    />
                  </div>
                </React.Fragment>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const DragHandle = sortableHandle(({ text }) => (
  <span className="drag-handle">
    <i className="fa-solid fa-bars mr-2"></i>
    Photo {text}
  </span>
));

const minResolution = (width, height) => {
  return function (fileInfo) {
    const imageInfo = fileInfo.originalImageInfo;
    const resolution = width * height;
    if (imageInfo !== null) {
      if (imageInfo.width * imageInfo.height < resolution) {
        throw new Error("minResolutionError");
      }
    }
  };
};

const SortableItem = sortableElement(
  ({
    public_key,
    value,
    index,
    onChange,
    onClear,
    minPixelsW,
    minPixelsH,
    image,
  }) => (
    <div className="bg-pale d-block mt-0 text-left p-2 multi-photo-items">
      <DragHandle text={value.position} />
      <div className="float-right">
        <CloudinaryUploaderWidget
          onChange={(info) => onChange(info)}
          onClear={() => onClear()}
          crop={value.crop_ratio}
          minPixelsW={minPixelsW}
          minPixelsH={minPixelsH}
          image={image}
        />
      </div>
    </div>
  )
);

const SortableContainer = sortableContainer(({ children }) => {
  return <div>{children}</div>;
});

class CloudinaryUploaderWidget extends React.Component {
  constructor(props) {
    super();
    this.state = {
      resolution_acceptable: props.resolution_acceptable,
      show_crop: props.show_crop,
    };
  }

  componentDidMount() {
    var myWidget = window.cloudinary.createUploadWidget(
      {
        cloudName: "framefox",
        uploadPreset: "framefox_default",
        showPoweredBy: false,
        autoMinimize: false,
        showAdvancedOptions: false,
        maxFileSize: 200000000,
        validateMaxWidthHeight: true,
        maxImageWidth: 10000,
        maxImageHeight: 10000,
        minImageWidth: this.props.minPixelsW,
        minImageHeight: this.props.minPixelsH,
        resourceType: "image",
        cropping: true,
        croppingAspectRatio: this.props.crop,
        showSkipCropButton: false,
        sources: [
          "local",
          "url",
          "camera",
          "google_drive",
          "dropbox",
          "instagram",
          "unsplash",
          "facebook",
        ],
        multiple: false,
        defaultSource: "local",
        styles: {
          palette: {
            window: "#FFFFFF",
            windowBorder: "#222",
            tabIcon: "#222",
            menuIcons: "#222",
            textDark: "#000000",
            textLight: "#FFFFFF",
            link: "#222",
            action: "#F8F6F0",
            inactiveTabIcon: "#4A3B33",
            error: "#F44235",
            inProgress: "#222",
            complete: "#222",
            sourceBg: "#FFFFFF",
          },
          fonts: {
            default: null,
            "'Figtree', sans-serif": {
              url: "https://fonts.googleapis.com/css?family=Figtree",
              active: true,
            },
          },
        },
      },
      (error, result) => {
        if (!error && result && result.event === "success") {
          this.props.onChange(result.info);
        }
      }
    );

    this.setState({ widget: myWidget });
  }

  render() {
    return (
      <div>
        {this.props.image ? (
          <button
            id="upload_widget"
            onClick={() => {
              this.props.onClear();
            }}
            className="btn btn-xs btn-secondary bg-stone-400"
          >
            <i className="fa-solid fa-circle-xmark mr-1"></i> Clear
          </button>
        ) : (
          <button
            id="upload_widget"
            onClick={() => {
              this.state.widget.open();
            }}
            className="btn btn-xs btn-primary"
          >
            <i className="fa-solid fa-arrow-up-from-bracket mr-2" />
            Upload a photo
          </button>
        )}
      </div>
    );
  }
}

export default MultiPhotoDesigner;
